<template>
  <div class="animated fadeIn">
    <div>
      <b-row>
        <div class="col-12">
          <b-card>
            <b-row class="mx-md-n3 mx-1">
              <div class="col-xl-3 col-lg-4 col-md-4 col mb-md-0 mb-3">
                <div v-if="loadingWarehouses">
                  <loading-animation />
                </div>
                <model-list-select
                  v-else
                  :list="warehouses"
                  option-value="id"
                  option-text="name"
                  v-model="selectedWarehouse"
                  placeholder="Selecione o Armazém"
                />
              </div>
              <div class="non-small-hide mobile-hide col-auto mb-3">
                <b-dropdown id="new-adjustment-dropdown" text="Novo Ajuste" variant="success" class="w-100">
                  <b-link to="/orders/item-adjustment/new" class="dropdown-item">Por Item</b-link>
                  <b-link to="/orders/location-and-lot-item-adjustment/new" class="dropdown-item">Inventário</b-link>
                </b-dropdown>
              </div>
              <div class="col-md col-12 mb-md-0 mb-3">
                <div class="row justify-content-start">
                  <div class="col">
                    <b-input-group>
                      <b-form-input
                        v-model="filter"
                        @keyup.enter="onFiltering"
                        type="number"
                        placeholder="Procurar por..."
                      />
                      <b-input-group-append>
                        <b-button size="md" text="Button" variant="outline-info" @click.passive="onFiltering">
                          <i class="cui-magnifying-glass"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <div class="col-auto pl-0">
                    <div class="row justify-content-md-start justify-content-end">
                      <div class="col-auto">
                        <button type="button" class="btn btn-outline-info cursor-pointer" @click="changeSortOption" v-b-tooltip.hover
                          :title="'Ordenação - ' + selectedSortOption.label">
                          <i :class="'fa fa-' + selectedSortOption.icon"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="small-hide col-sm-auto col-12">
                <div class="row justify-content-end">
                  <b-dropdown id="new-adjustment-dropdown" text="Novo Ajuste" variant="success" class="col-sm col-auto">
                    <b-link to="/orders/item-adjustment/new" class="dropdown-item">Por Item</b-link>
                    <b-link to="/orders/location-and-lot-item-adjustment/new" class="dropdown-item">Inventário</b-link>
                  </b-dropdown>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mt-sm-3 mt-2">
                    <div class="row align-items-center">
                      <div class="col-sm-auto col-12 mb-sm-0 mb-1">
                        <label class="mb-0">Item:</label>
                      </div>
                      <div class="col">
                        <div v-if="loadingItems">
                          <loading-animation />
                        </div>
                        <model-list-select
                          v-else
                          :list="items"
                          option-value="id"
                          option-text="label"
                          v-model="selectedItem"
                          placeholder="Digite para pesquisar..."
                          @searchchange="searchItem"
                          @keyup.enter="onFiltering"
                          :filterPredicate="alwaysTrueFilterPredicate"
                        />
                      </div>
                    </div>
                  </div>

                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mt-sm-3 mt-2">
                  <div class="row align-items-center">
                    <div class="col-sm-auto col-12 mb-sm-0 mb-1">
                      <label for="locationSelect">Endereço:</label>
                    </div>

                    <div class="col">
                      <div v-if="searchLocationInProcess">
                        <loading-animation />
                      </div>
                      <model-list-select
                        id="locationSelect"
                        :list="locations"
                        option-value="id"
                        option-text="name"
                        v-model="selectedLocation"
                        placeholder="Digite para pesquisar..."
                        @searchchange="searchLocation"
                        :filterPredicate="alwaysTrueFilterPredicate"
                      />
                    </div>
                  </div>
                </div>

                </div>
              </div>
            </b-row>
          </b-card>
        </div>
      </b-row>

      <b-row>
        <div class="col-12">
          <b-tabs
            lazy
          >
            <b-tab :active="activeTabIndex == 0" @click="tabChanged" class="px-md-3 px-0">
              <template slot="title">
                <p>Pendentes</p>
              </template>

              <OrderTable
                id="released"
                resourceName="orderResourceList"
                :url="endpoints.findAll"
                role="PEN"
                movementType="AJU"
                ref="releasedTable"
                :enableEdit="true"
                :enableCancel="userOrderCancelRestrictions.allow"
                :isUserManager="isUserManager"
              >

              </OrderTable>
            </b-tab>
            <b-tab :active="activeTabIndex == 1" @click="tabChanged" class="px-md-3 px-0">
              <template slot="title">
                <p>Em conferência</p>
              </template>

              <OrderTable
                id="inCheck"
                resourceName="orderResourceList"
                :url="endpoints.findAll"
                role="CHE"
                movementType="AJU"
                ref="inCheckTable"
                :enableEdit="true"
                :enableCancel="userOrderCancelRestrictions.allow"
                :isUserManager="isUserManager"
              >

              </OrderTable>
            </b-tab>
            <b-tab :active="activeTabIndex == 2" @click="tabChanged" class="px-md-3 px-0">
              <template slot="title">
                <p>Finalizados</p>
              </template>
              <OrderTable
                id="complete"
                resourceName="orderResourceList"
                :url="endpoints.findAll"
                role="FIN"
                movementType="AJU"
                ref="completeTable"
                :enableOpen="true"
                :isUserManager="isUserManager"
              />
            </b-tab>
            <b-tab :active="activeTabIndex == 3" @click="tabChanged" class="px-md-3 px-0">
              <template slot="title">
                <p>Cancelados</p>
              </template>
              <OrderTable
                id="canceled"
                resourceName="orderResourceList"
                :url="endpoints.findAll"
                role="CAN"
                movementType="AJU"
                ref="canceledTable"
                :enableOpen="true"
                :isUserManager="isUserManager"
              />
            </b-tab>
          </b-tabs>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { OrderTable}  from '@/components/tables'
  import { ModelListSelect } from 'vue-search-select'
  import { httpClient } from '@/service'
  import { LoadingAnimation } from '@/components/loaders'
  import shared from '@/shared/shared'

  export default {
    name: 'items-adjustment-all',

    components: { OrderTable, ModelListSelect, LoadingAnimation },

    data () {
      return {
        endpoints: {
          findAll: process.env.VUE_APP_API_URL + 'stock-adjustments'
        },
        filter: null,
        warehouses: [],
        selectedWarehouse: {},
        loadingWarehouses: false,
        sortOptions: [
          { value: 'asc', label: 'Ascendente', icon: 'sort-down' },
          { value: 'desc', label: 'Descendente', icon: 'sort-up' }
        ],
        selectedSortOption: {},
        items: [{id: null, label: 'Todos'}],
        loadingItems: false,
        selectedItem: {},
        activeTabIndex: 0,
        isUserManager: false,
        authUser: false,
        searchLocationInProcess: false,
        locations: [],
        selectedLocation: {},
        locationSearchTimeout: null,
        userOrderCancelRestrictions: {},
        parameter: null
      }
    },

    beforeMount() {
      this.activeTabIndex = Number(shared.getLocalStorageString('AJU/activeTabIndex') || 0);
      this.filter = shared.getLocalStorageString('AJU/filterText');
      this.selectedSortOption = shared.getLocalStorageObj('order/selectedSortOption');

      if (!this.selectedSortOption || !this.selectedSortOption.value) {
        this.selectedSortOption = this.sortOptions[0];
      }

      this.setIsUserManager();
    },

    mounted : async function () {
      //const { allOrderIn, allOrderInComplete } = localStorage.getItem('endpoints/order');
      //this.urlAllPrepare = allOrderIn.href
      //this.urlAllComplete = allOrderInComplete.href

      await this.$store.dispatch('app/changePage', { title:'Ajustes', size: 4 })
      this.getWarehouses();
      this.selectedWarehouse = shared.getLocalStorageObj('order/warehouse');

      this.selectedItem = shared.getLocalStorageObj('order/filterItem');
      if (this.selectedItem && this.selectedItem.id && Object.keys(this.selectedItem).length) {
        this.items.push(this.selectedItem);
        this.setItemsLabel();
      }

      this.selectedLocation = shared.getLocalStorageObj('order/filterLocation');
      if (this.selectedLocation && this.selectedLocation.id && Object.keys(this.selectedLocation).length) {
        this.locations.push(this.selectedLocation);
      }

      this.onFiltering();
    },

    beforeRouteLeave (to, from, next) {
      this.getTable().beforeRouteLeave();
      next(true);
    },

    computed: {
      isLocationSelected() {
        return this.selectedLocation && this.selectedLocation.id;
      }
    },

    methods: {
      getTable() {
        return this.$refs.releasedTable || this.$refs.inCheckTable || this.$refs.completeTable || this.$refs.canceledTable;
      },

      onFiltering() {
        shared.setLocalStorageString('AJU/filterText', this.filter);

        if (this.$refs.releasedTable)
          shared.setLocalStorageString('AJU/activeTabIndex', 0);

        else if (this.$refs.inCheckTable)
          shared.setLocalStorageString('AJU/activeTabIndex', 1);

        else if (this.$refs.completeTable)
          shared.setLocalStorageString('AJU/activeTabIndex', 2);

        else if (this.$refs.canceledTable)
          shared.setLocalStorageString('AJU/activeTabIndex', 3);

        this.getTable().filter({
          filterText: this.filter,
          warehouse: this.selectedWarehouse,
          item: this.selectedItem,
          operation: {},
          page: null,
          sort: this.selectedSortOption.value,
          ticketStatus: {},
          location: this.selectedLocation,
          route: {}
        });
      },

      getWarehouses() {
        this.loadingWarehouses = true;
        httpClient
        .post(`${process.env.VUE_APP_API_URL}stock-locales/condition?page=${0}&size=${100}`, {
          conditions: [{
            field: 'active',
            value: true
          }]
        }).then(({ data }) => {
          this.loadingWarehouses = false;
          this.warehouses = data.data.content;
          this.warehouses.unshift({id: null, name: 'Todos'});
        })
        .catch((error) => {
          this.loadingWarehouses = false;
          if (error.message) {
            this.$notify.error(error)
          } else {
            this.$notify.textError("Houve um erro ao buscar os armazéns");
          }
        });
      },

      tabChanged() {
        this.$nextTick(() => {
          this.onFiltering();
        });
      },

      changeSortOption() {
        if (this.selectedSortOption.value === this.sortOptions[0].value) {
          this.selectedSortOption = this.sortOptions[1];
        } else {
          this.selectedSortOption = this.sortOptions[0];
        }

        shared.setLocalStorageObj('order/selectedSortOption', this.selectedSortOption);
        this.onFiltering();
      },

      async searchItem (searchText) {
        if (!this.searchItemInProcess && (
          (searchText && searchText.length) || !this.selectedItem || Object.keys(this.selectedItem).length == 0
        )) {
          if (this.itemSearchTimeout) {
            clearTimeout(this.itemSearchTimeout);
          }

          this.itemSearchTimeout = setTimeout(() => {
            this.searchItemInProcess = true

            if (searchText && searchText.length) {
              httpClient
              .post(`${process.env.VUE_APP_API_URL}items/condition?page=${0}&size=${10}`, {
                conditions: [
                  {
                    logicalOperator: 'OR',
                    conditions: [
                      {
                        field: 'description',
                        conditionalOperator: 'LIKE_START',
                        value: searchText
                      },
                      {
                        field: 'ref',
                        conditionalOperator: 'LIKE_END',
                        value: shared.mountReduzidoFilter(searchText)
                      },
                      {
                        field: 'sku',
                        conditionalOperator: 'LIKE_END',
                        value: searchText
                      },
                      {
                        field: 'gtin',
                        conditionalOperator: 'LIKE_END',
                        value: searchText
                      }
                    ]
                  }
                ]
              })
              .then(({ data }) => {
                this.items = this.handleData(data);
                this.setItemsLabel(searchText);
                this.items.unshift({id: null, label: 'Todos'});
              })
              .catch((error) => {
                this.searchItemInProcess = false
                if (error.message) {
                  this.$notify.error(error)
                }
              });
            } else {
              httpClient
              .get(`${process.env.VUE_APP_API_URL}items/?page=${0}&size=${10}`)
              .then(({ data }) => {
                this.items = this.handleData(data);
                this.setItemsLabel(searchText);
                this.items.unshift({id: null, label: 'Todos'});
              })
              .catch((error) => {
                this.searchItemInProcess = false
                if (error.message) {
                  this.$notify.error(error)
                }
              });
            }
          }, 500);
        }
      },

      handleData(data) {
        this.searchItemInProcess = false
        //this.totalRows = data.data.totalElements
        const items = data.data.content

        return items
      },

      getItemLabel(item) {
        return shared.getItemLabel(item);
      },

      setItemsLabel(searchText = null) {
        if (this.items && this.items.length) {
          this.items.forEach(item => {
            if (item.id) {
              item.label = this.getItemLabel(item);
            }
          });
        }
      },

      alwaysTrueFilterPredicate() {
        return true;
      },

      setIsUserManager() {
        this.authUser = shared.getLocalStorageObj('auth/user');
        this.parameter = shared.getParameterFromAuthUser(this.authUser);

        if (this.authUser && this.authUser.profile && this.authUser.profile.modules) {
          let adjustmentsProfileModule = this.authUser.profile.modules.find(pm => {
            return pm.name && pm.name.toString().toUpperCase() == "ADJUSTMENTS"
          });

          this.isUserManager = adjustmentsProfileModule && adjustmentsProfileModule.canExecute;
        }

        this.userOrderCancelRestrictions = shared.getUserOrderCancelRestrictions(this.authUser);
      },

      async searchLocation(searchText) {
        if (
          !this.searchLocationInProcess &&
          ((searchText && searchText.length) ||
            !this.selectedLocation ||
            Object.keys(this.selectedLocation).length == 0)
        ) {

            if (this.locationSearchTimeout) {
              clearTimeout(this.locationSearchTimeout);
            }

            let conditions = [
              {
                field: "name",
                conditionalOperator: "LIKE_START",
                value: searchText,
              }
            ];

            if (this.selectedWarehouse && this.selectedWarehouse.id) {
              conditions.push({
                field: 'stockLocale.id',
                value: this.selectedWarehouse.id
              });
            }

            this.locationSearchTimeout = setTimeout(() => {
              this.searchLocationInProcess = true;

              httpClient
                .post(
                  `${
                    process.env.VUE_APP_API_URL
                  }locations/condition?page=${0}&size=${10}`,
                  {
                    conditions: conditions,
                  }
                )
                .then(({ data }) => {
                  this.locations = this.handleLocationData(data);
                })
                .catch((error) => {
                  this.searchLocationInProcess = false;
                  if (error.message) {
                    this.$notify.error(error);
                  }
                });
            }, 500);
        }
      },

      handleLocationData(data) {
        this.searchLocationInProcess = false;
        //this.totalRows = data.data.totalElements;
        const locations = data.data.content;
        locations.push({ id: null, name: "Todos" });

        return locations;
      }
    },

    watch: {
      'selectedWarehouse': function(newVal, oldVal) {
        shared.setLocalStorageObj('order/warehouse', shared.setLocalStorageObj(this.selectedWarehouse));

        if (!shared.entitiesAreEqual(newVal, oldVal)) {
          this.onFiltering();
        }
      },
      'selectedItem': function(newVal, oldVal) {
        shared.setLocalStorageObj('order/filterItem', this.selectedItem);

        if (!shared.entitiesAreEqual(newVal, oldVal)) {
          this.onFiltering();
        }
      },
      'selectedLocation': function(newVal, oldVal) {
        shared.setLocalStorageObj('order/filterLocation', this.selectedLocation);

        if (!shared.entitiesAreEqual(newVal, oldVal)) {
          this.onFiltering();
        }
      },
    }
  }
</script>
